export default {
  list: [
    {
      value: 'false',
      title: 'قابل استفاده',

    },
    {
      value: 'true',
      title: 'استفاده شده',
    },
    {
      value: 'null',
      title: 'هردو'
    },
  ],
  values: {
    BOTH: 'BOTH',
    USEABLE: 'USABLE',
    USED: 'USED'
  }
}